module.exports = __webpack_public_path__ + "img/reg.d0289dc0.png";